import { CAROUSEL_WINDOW_SIZE } from './cost-to-build-client-ui-carousel.constants';
import type { CarouselState, CarouselThumbnail } from './cost-to-build-client-ui-carousel.types';

export const CAROUSEL_INITIAL_STATE: CarouselState = {
    ariaLabel: '',
    id: '',
    label: '',
    selectedId: '',
    thumbnails: [],
    windowOffset: 0,
    windowSize: CAROUSEL_WINDOW_SIZE,
};

const areThumbnailsEqual = (left: readonly CarouselThumbnail[], right: readonly CarouselThumbnail[]) => {
    if (left === right) {
        return true;
    }

    if (left.length !== right.length) {
        return false;
    }

    return left.every((thumbnail, index) => {
        const other = right[index];
        return (
            thumbnail.id === other.id &&
            thumbnail.imageUrl === other.imageUrl &&
            thumbnail.overlayNote === other.overlayNote &&
            thumbnail.title === other.title
        );
    });
};

export const areCarouselStatesEqual = (left: CarouselState, right: CarouselState) =>
    left.ariaLabel === right.ariaLabel &&
    left.id === right.id &&
    left.label === right.label &&
    left.selectedId === right.selectedId &&
    left.windowOffset === right.windowOffset &&
    left.windowSize === right.windowSize &&
    areThumbnailsEqual(left.thumbnails, right.thumbnails);
